import React from "react";
import { Dialog, Box, IconButton, Typography, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function isImage(mimeType) {
  return mimeType.startsWith("image/");
}
function isPdf(mimeType) {
  return mimeType === "application/pdf";
}
export default function FilePreviewModal({
  open,
  onClose,
  url,
  filename,
  mimeType
}) {
  const canPreview = isImage(mimeType) || isPdf(mimeType);
  return /*#__PURE__*/_jsx(Dialog, {
    open: open,
    onClose: onClose,
    maxWidth: "lg",
    fullWidth: isPdf(mimeType)
    // The task detail Drawer sits at modal+1 — the preview must
    // stack above it or screenshots open behind the drawer.
    ,
    sx: {
      zIndex: theme => theme.zIndex.modal + 2
    },
    children: /*#__PURE__*/_jsxs(Box, {
      sx: {
        position: "relative",
        bgcolor: canPreview ? "black" : "background.paper",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: canPreview ? 400 : 200
      },
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          position: "absolute",
          top: 8,
          right: 8,
          display: "flex",
          gap: 1,
          zIndex: 1
        },
        children: [/*#__PURE__*/_jsx(IconButton, {
          component: "a",
          href: url,
          download: filename,
          target: "_blank",
          rel: "noopener noreferrer",
          sx: {
            color: canPreview ? "white" : "text.primary",
            bgcolor: canPreview ? "rgba(0,0,0,0.5)" : "action.hover"
          },
          children: /*#__PURE__*/_jsx(DownloadIcon, {})
        }), /*#__PURE__*/_jsx(IconButton, {
          onClick: onClose,
          sx: {
            color: canPreview ? "white" : "text.primary",
            bgcolor: canPreview ? "rgba(0,0,0,0.5)" : "action.hover"
          },
          children: /*#__PURE__*/_jsx(CloseIcon, {})
        })]
      }), isImage(mimeType) && /*#__PURE__*/_jsx("img", {
        src: url,
        alt: filename,
        style: {
          maxWidth: "90vw",
          maxHeight: "85vh",
          objectFit: "contain"
        }
      }), isPdf(mimeType) && /*#__PURE__*/_jsx(Box, {
        component: "iframe",
        src: url,
        title: filename,
        sx: {
          width: "100%",
          height: "80vh",
          border: "none"
        }
      }), !canPreview && /*#__PURE__*/_jsxs(Box, {
        sx: {
          textAlign: "center",
          p: 4
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          sx: {
            mb: 1
          },
          children: filename
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "body2",
          color: "text.secondary",
          sx: {
            mb: 2
          },
          children: "Preview not available for this file type."
        }), /*#__PURE__*/_jsx(Button, {
          variant: "contained",
          component: "a",
          href: url,
          download: filename,
          target: "_blank",
          rel: "noopener noreferrer",
          startIcon: /*#__PURE__*/_jsx(DownloadIcon, {}),
          children: "Download"
        })]
      })]
    })
  });
}